import React from 'react';
import { IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';

import { UserRegisterForm } from 'components/user/UserRegisterForm';
import { BackButton } from 'components/common/buttons/BackButton';

import { useRedirectIfLoggedIn } from 'auth';

export const UserRegisterPage: React.FC = () => {
  useRedirectIfLoggedIn();

  return (
    <IonPage>
      <IonHeader mode="ios">
        <IonToolbar mode="ios">
          <IonButtons className="header">
            <BackButton defaultHref="/welcome" />
          </IonButtons>
          <IonTitle>ユーザー登録</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <UserRegisterForm />
      </IonContent>
    </IonPage>
  );
};
